var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDotdotdot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 4,
    viewBox: "0 0 13 4",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.59375 1.75C0.59375 1.20312 0.867188 0.710938 1.35938 0.4375C1.82422 0.164062 2.39844 0.164062 2.89062 0.4375C3.35547 0.710938 3.65625 1.20312 3.65625 1.75C3.65625 2.32422 3.35547 2.81641 2.89062 3.08984C2.39844 3.36328 1.82422 3.36328 1.35938 3.08984C0.867188 2.81641 0.59375 2.32422 0.59375 1.75ZM4.96875 1.75C4.96875 1.20312 5.24219 0.710938 5.73438 0.4375C6.19922 0.164062 6.77344 0.164062 7.26562 0.4375C7.73047 0.710938 8.03125 1.20312 8.03125 1.75C8.03125 2.32422 7.73047 2.81641 7.26562 3.08984C6.77344 3.36328 6.19922 3.36328 5.73438 3.08984C5.24219 2.81641 4.96875 2.32422 4.96875 1.75ZM10.875 0.21875C11.4219 0.21875 11.9141 0.519531 12.1875 0.984375C12.4609 1.47656 12.4609 2.05078 12.1875 2.51562C11.9141 3.00781 11.4219 3.28125 10.875 3.28125C10.3008 3.28125 9.80859 3.00781 9.53516 2.51562C9.26172 2.05078 9.26172 1.47656 9.53516 0.984375C9.80859 0.519531 10.3008 0.21875 10.875 0.21875Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDotdotdot);
export default __webpack_public_path__ + "static/media/dotdotdot.e43872ea2dd66d156fe4bae0960d22e9.svg";
export { ForwardRef as ReactComponent };